import { sanityClient } from '@/utils/sanityClient';

export const searchGames = (query: string, providerName?: string) => {
  return sanityClient.fetch<Game[]>(
    `*[_type == 'game' && enabled == true && name match "${query}*" ${
      providerName
        ? `&& gameProvider->.internalIntegrationId == "${providerName}"`
        : ''
    }] {
        name,
        "features": gameFeatures[]->meta.en.name,
        "themes": gameThemes[]->meta.en.name,
        "gameCategory": gameCategory->.meta.en.name,
        "studio": gameStudio->.name,
        "slug": slug.current,
        "desktopId": desktopLaunchId,
        "mobileId": mobileLaunchId,
        "thumbnail": thumbnail.thumbnail,
        "thumbnailUpdatedAt": thumbnail.updatedAt,
        "provider": gameProvider->.name
      }[0..50]
    `,
  );
};

export type GameOption = {
  itemId: string;
  name: string;
  mobileId?: string | null;
  desktopId?: string | null;
  providerName?: string | null;
};

type GameDescriptorJson = {
  name?: string;
  slug?: string;
  studio?: string;
  provider?: string;
  gameProvider?: { name?: string };
};

/**
 * Finds the Sanity game matching a game descriptor coming from the API,
 * so its launch ids can be reused (e.g. when cloning a free spins reward).
 */
export const fetchGameByDescriptor = async (
  json: unknown,
): Promise<GameOption | null> => {
  if (!json || typeof json !== 'object') {
    return null;
  }

  const { name, slug } = json as GameDescriptorJson;

  if (!slug && !name) {
    return null;
  }

  const game = await sanityClient
    .fetch<{
      name: string;
      slug: string;
      studio?: string;
      desktopId?: string;
      mobileId?: string;
      provider?: string;
    } | null>(
      `*[_type == 'game' && ${
        slug ? 'slug.current == $slug' : 'name == $name'
      }][0] {
        name,
        "studio": gameStudio->.name,
        "slug": slug.current,
        "desktopId": desktopLaunchId,
        "mobileId": mobileLaunchId,
        "provider": gameProvider->.name
      }`,
      { slug: slug ?? null, name: name ?? null },
    )
    .catch(() => null);

  if (!game) {
    return null;
  }

  return {
    itemId: `${game.studio}/${game.slug}`,
    name: game.name,
    mobileId: game.mobileId,
    desktopId: game.desktopId,
    providerName: game.provider,
  };
};
